import {ModuleState} from '@gongxigames/framework/slot/fragments/module/ModuleState';
import {AbstractReelsView} from '@gongxigames/framework/slot/modules/reels/AbstractReelsView';
import {ReelsModule} from '@gongxigames/framework/slot/modules/reels/ReelsModule';
import {ReelConstants} from '@gongxigames/framework/slot/utils';

export class ReelsInitState extends ModuleState<AbstractReelsView, ReelsModule> {
    public onEnterState(): void {
        this.view.setupReelStrip(this.module.reels, ReelConstants);

        this.module.gotoState(ReelsModule.BASIC_STATE);
    }

    public onLeaveState(): void {
    }

    protected setupEvents(): void {
    }

}
